import { render, staticRenderFns } from "./AdjustComponent.vue?vue&type=template&id=6f80d9f5&scoped=true&"
import script from "./AdjustComponent.vue?vue&type=script&lang=js&"
export * from "./AdjustComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80d9f5",
  null
  
)

export default component.exports